module.exports = __webpack_public_path__ + "static/media/farm-credit-light-mode.015296c1.png";